import { Link, useLocation } from 'react-router';
import { CircleUserRound, GalleryVerticalEnd, UsersRound } from 'lucide-react';
import { paths } from '@/navigation/paths';
import styles from './BottomNavigation.module.css';

const navigationItems = [
  { path: paths.home(), label: 'Clients', icon: UsersRound },
  { path: paths.passEditor(), label: 'Templates', icon: GalleryVerticalEnd },
  { path: paths.profile(), label: 'Profile', icon: CircleUserRound, testId: 'profile-button' },
];

export function BottomNavigation() {
  const { pathname } = useLocation();
  const activePath =
    pathname.startsWith('/client-profile/') || pathname === paths.addClient()
      ? paths.home()
      : pathname;
  return (
    <nav className={styles.bottomNavigation} aria-label="Main navigation">
      {navigationItems.map(({ path, label, icon: Icon, testId }) => (
        <Link
          key={path}
          to={path}
          aria-current={activePath === path ? 'page' : undefined}
          className={`${styles.navigationItem} ${activePath === path ? styles.navigationItemActive : ''}`}
          data-testid={testId}
        >
          <Icon className={styles.navigationIcon} size={24} strokeWidth={1.8} aria-hidden="true" />
          <span className={styles.navigationLabel}>{label}</span>
        </Link>
      ))}
    </nav>
  );
}
